export class State {
  public error = '';
  public userTypes = [];
  userPermissions = [];
  rolePerm = {};
  userRolePermission = {};
}